export const ROLES ={
    WHITE_LABEL_PARTNER_ADMIN: 'White Label Partner Admin',
    CHILD_ACCOUNT: 'Child Account'
}